var _excluded = ["olLayer", "customLoader"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import OlWMS from 'ol/source/WMTS';
import { useEffect, useMemo } from 'react';
import { getOptions } from '../utils';
import { useDeepCompareMemoize } from 'use-deep-compare-effect';
var allWMSOptions = {
  attributions: undefined,
  cacheSize: undefined,
  crossOrigin: undefined,
  imageSmoothing: undefined,
  tileGrid: undefined,
  projection: undefined,
  reprojectionErrorThreshold: undefined,
  requestEncoding: undefined,
  layer: undefined,
  style: undefined,
  tileClass: undefined,
  tilePixelRatio: undefined,
  format: undefined,
  version: undefined,
  matrixSet: undefined,
  dimensions: undefined,
  url: undefined,
  tileLoadFunction: undefined,
  urls: undefined,
  wrapX: undefined,
  transition: undefined
};

var WMTS = _ref => {
  var {
    olLayer,
    customLoader
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var memoizedProps = useDeepCompareMemoize(props);
  var memoizedOptions = useMemo(() => getOptions(Object.assign(allWMSOptions, memoizedProps)), [memoizedProps]);
  useEffect(() => {
    var source = new OlWMS(memoizedOptions); // Sets WMTS layer features loader

    customLoader && source.setTileLoadFunction(customLoader);
    olLayer === null || olLayer === void 0 ? void 0 : olLayer.setSource(source);
    return () => {
      var _olLayer$getSource;

      olLayer === null || olLayer === void 0 ? void 0 : (_olLayer$getSource = olLayer.getSource()) === null || _olLayer$getSource === void 0 ? void 0 : _olLayer$getSource.dispose();
    };
  }, [customLoader, memoizedOptions, olLayer]);
  return null;
};

export default WMTS;